import { HttpInterceptorFn } from '@angular/common/http';
import { secureStorage } from '../data-access/services/localstorage.service';

// Pantallas públicas de los cursos de cap7: /academy (aula) y /cursos/:nombre (registro).
export function enPantallaDeAcademy(): boolean {
  const ruta = window.location.pathname;
  return ruta === '/academy' || ruta.startsWith('/academy/') || /^\/cursos\/[^/]+\/?$/.test(ruta);
}

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  // Intentos para obtener un token válido, en orden de prioridad
  // 1. Token de cursos (sessionStorage)
  // 2. Token principal de la app (localStorage)
  // 3. Token temporal para vistas compartidas (sessionStorage)
  const tokenPrincipal = secureStorage.getItem('tokenP');
  // El token de academy solo sirve en las rutas de cursos del backend: si en la misma pestaña también
  // hay sesión de staff, fuera de academy se usa la de staff para que el panel no reciba 401.
  const tokenCursos = !tokenPrincipal || enPantallaDeAcademy() ? secureStorage.getSessionItem('token_cursos') : null;
  const tokenTemp = secureStorage.getSessionItem('token_temp');
  const token = tokenCursos || tokenPrincipal || tokenTemp;

  if (token) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return next(authReq);
  }

  return next(req);
};
